import React, { FC } from 'react';
import { Text } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';

interface NCFilePerformanceUtilizationProps extends NavigationProps {}

const NCFilePerformanceUtilization: FC<NCFilePerformanceUtilizationProps> = ({ lg }) => {
  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
    >
      <Text>NCFilePerformanceUtilization</Text>
    </MachinesProvider>
  );
};

export { NCFilePerformanceUtilization };
